import { render, staticRenderFns } from "./SingleSignOnApple.vue?vue&type=template&id=39ad9a1a"
import script from "./SingleSignOnApple.vue?vue&type=script&setup=true&lang=ts"
export * from "./SingleSignOnApple.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports